import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { usuarioService } from '@services'


// El componente PrivateRouteUser representa un componente de ruta si el usuario ha iniciado sesión
// si el usuario no ha iniciado sesión, se le redirige a la /login página




function PrivateRouteUser({ component: Component, ...rest }) {
    return (
        <Route {...rest} render={props => {
            const usuario = usuarioService.usuarioValue;
            // si el usuario no esta logueado...
            if (!usuario) {
                
                return <Redirect to={{ pathname: `${process.env.PUBLIC_URL}/usuario/login`, state: { from: props.location } }} />
            }

    
            
            // authorized so return component
            return <Component {...props} />
        }} />
    );
}

export { PrivateRouteUser };